import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateUtil } from "@utils";
import { NationalDataAuthType } from "@utils/Constants";

type UserInfoSliceState = {
  authType?: NationalDataAuthType;
  name: string;
  phone: string;
  birthday: string;
  // telcoTycd?: TelcoType;
  agreed: boolean;
};

const initialState: UserInfoSliceState = {
  authType: undefined,
  name: "",
  phone: "",
  birthday: "",
  // telcoTycd: undefined,
  agreed: false,
};

export type SetUserInfoActionType = PayloadAction<{
  authType: NationalDataAuthType;
  name: string;
  phone: string;
  birthday: string;
  // telcoTycd?: TelcoType;
}>;

const userInfoSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setUserInfo: (state, action: SetUserInfoActionType) => {
      const { authType, name, phone, birthday /* telcoTycd */ } =
        action.payload;

      state.authType = authType;
      state.name = name;
      state.phone = phone.replace(/-/g, "");
      state.birthday = DateUtil.getDateString(DateUtil.convertToDate(birthday));
      // state.telcoTycd = telcoTycd;
    },
    setAgreed: (state, action: PayloadAction<boolean>) => {
      state.agreed = action.payload;
    },
  },
});

export const { setUserInfo, setAgreed } = userInfoSlice.actions;

export default userInfoSlice.reducer;
